import React, { createContext, useCallback, useContext } from 'react';

const FPOContext = createContext(null);

export function FPOProvider({ organisation, setOrganisation, children }) {
  const refresh = useCallback(async () => {
    const { organisationsApi } = await import('../../../api/organisations');
    const org = await organisationsApi.me();
    setOrganisation(org);
    return org;
  }, [setOrganisation]);

  return (
    <FPOContext.Provider value={{ organisation, refresh, setOrganisation }}>
      {children}
    </FPOContext.Provider>
  );
}

export function useFPO() {
  const ctx = useContext(FPOContext);
  if (!ctx) {
    throw new Error('useFPO must be used inside <FPOProvider>');
  }
  return ctx;
}
